import { useAIStudioCreditsDialog } from 'src/components/pages/aiStudio/components/dialogs/aiStudioNoCreditsDialog';

/**
 * Product-setup no-credits dialog, shown when generating side images (Print Areas / Variants steps, AI assistant)
 * reports NO_CREDITS. With the AI credit model there are no credit packs to buy: only a trial or a Shopify
 * development store whose one-time free AI credits are used up gets here, so the same dialog of AI Studio is shown.
 */
export function useSideImagesNoCreditsDialog(): { showSideImagesNoCreditsDialog: () => void } {
    const { showNoCreditsDialog } = useAIStudioCreditsDialog();

    return { showSideImagesNoCreditsDialog: showNoCreditsDialog };
}
